import {useMutation} from '@tanstack/react-query';
import {ManualPriceUpdateForm, ManualPriceUpdateMutation, ManualPriceUpdateProps} from './manual-price-update.model';
import {AxiosHttpClient} from '../../envisia/auth/axios-http-client';
import {useAxiosError} from '../errorhandling/useAxiosError';
import {environment} from '../../../environments/environment';

export function useManualPriceUpdateMutation(props: ManualPriceUpdateProps): ManualPriceUpdateMutation {
  const {mutate, isPending, error} = useMutation({
    mutationFn: (form: ManualPriceUpdateForm) =>
      AxiosHttpClient.put<void>(
        `${environment.apiv4uri}prices/${props.oaNr}/manual/${
          (props.labelButton === 'Preise erhöhen' ? 'all' : props.price.id)}`,
        form,
        null,
        true,
      ),
  });

  const axiosError = useAxiosError<void>(error);
  return {
    isPending,
    error: axiosError,
    mutate: (f, success) => mutate(f, {onSuccess: () => success()}),
  };
}
